/**
 * Numeración interna no fiscal (INV-000001).
 * No usar para comprobantes ARCA — el worker asignará numeración fiscal.
 */
const PREFIX = 'INV-';

export function formatInternalInvoiceNumber(sequence: number): string {
  return `${PREFIX}${String(sequence).padStart(6, '0')}`;
}

export function parseInternalInvoiceSequence(invoiceNumber: string): number | null {
  const match = /^INV-(\d+)$/.exec(invoiceNumber.trim());
  if (!match?.[1]) return null;
  const n = Number.parseInt(match[1], 10);
  return Number.isFinite(n) ? n : null;
}

export function maxInternalSequenceFromNumbers(numbers: string[]): number {
  let max = 0;
  for (const num of numbers) {
    const seq = parseInternalInvoiceSequence(num);
    if (seq !== null && seq > max) max = seq;
  }
  return max;
}
